import React, {Component} from "react";
import Loading from "../../components/Loading";
import Conditional from "../../components/Conditional";
import "./OrderSummary.css";

class OrderSummary extends Component {

  render() {
    let {data} = this.props;
    let currency = data.get("currency");
    let showDiscount = (data.get("promoCodeApplied") === true);
    let discount = `${currency} -${data.get("discount")}`;
    let taxes = `${currency} ${data.get("subtotalTaxes")}`;
    let total = `${currency} ${data.get("total")}`;
    if (data.get("isPreparing")) {
      discount = <Loading key="discount-loading" />
      taxes = <Loading key="taxes-loading" />
      total = <Loading key="total-loading" />
    }
    return (
      <div className="OrderSummary">
        <div className="title">Order Summary</div>
        <div className="content">
          <table>
            <tbody>
              <tr>
                <td>Products:</td>
                <td>{currency} {data.get("subtotalProducts")}</td>
              </tr>
              <Conditional show={showDiscount}>
                <tr>
                  <td>Promo Code Discount:</td>
                  <td>{discount}</td>
                </tr>
              </Conditional>
              <tr>
                <td>Taxes:</td>
                <td>{taxes}</td>
              </tr>
              <tr className="large-separator">
                <td colSpan="2"><hr/></td>
              </tr>
              <tr className="order-total">
                <td>Order Total:</td>
                <td>{total}</td>
              </tr>
            </tbody>
          </table>
        </div>        
      </div>
    )
  }

}

export default OrderSummary;